import {
  Paper,
  Grid,
  Button,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  Collapse,
  TextField,
  Select,
  Input,
  MenuItem,
} from "@material-ui/core";
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { styles } from "./styles";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import Header from "../../../partials/header";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { formatDatetime } from "../../../utils/setting";
import TableFormat from "../../../partials/TableFormat";
import TextForm from "../../../partials/textForm";
import LabelForm from "../../../partials/labelForm";
import { getNumberOnString } from "../../../partials/validateNumber";
import InputFormat from "../../../partials/inputForm";
import NumberFormatCustom from "../../numberFormat";
import classNames from "classnames";
import DialogNotice from "../../dialog";
import PriceFormat from "../../../partials/priceFormat";

const status = [
  {
    value: "new",
    label: "new",
    color: "rgb(45, 148, 178)",
  },
  {
    value: "processing",
    label: "processing",
    color: "rgb(225, 210, 36)",
  },
  {
    value: "cancel",
    label: "cancel",
    color: "rgb(208, 53, 53)",
  },
  {
    value: "done",
    label: "done",
    color: "rgb(130, 193, 77)",
  },
  {
    value: "abort",
    label: "abort",
    color: "rgb(208, 53, 53)",
  },
];
const headCellsPayment = [
  {
    key: "moneyReceived",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_receive_money",
  },
  {
    key: "moneyChange",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_money_change",
  },
  {
    key: "paymentMethod",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_payment_method",
  },
  {
    key: "updatedAt",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_updatedAt",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];
const headCellsOrderItem = [
  {
    key: "name",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_item_name",
  },
  {
    key: "quantity",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_item_quantity",
  },
  {
    key: "price",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_item_price",
  },
  {
    key: "total",
    numeric: false,
    disablePadding: false,
    label: "orders_detailorder_total",
  },
];
class DetailOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: [],
      newMoneyReceived: "",
      newMoneyChange: "",
      newPaymentMethod: "cash",
      addNewPayment: false,
      detailOrder: {},
      editMoneyReceived: 0,
      editMoneyChange: 0,
      editPaymentMethod: "cash",
      indexDelete: -1,
    };
  }
  async componentDidMount() {
    const { match } = this.props;
    let data = {
      orderCode: match.params._id,
    };
    this.loading.startLoading();
    this.props.getSettings();
    let check = await this.props.findByCode(data);
    if (check.code === 1) {
      this.setState({ detailOrder: check.data });
    }
    this.loading.stopLoading();
  }
  renderStatus = (statusOrder) => {
    const { classes, t } = this.props;
    let item = status.find((order) => order.value === statusOrder);
    if (item) {
      return (
        <Button
          classes={{
            root: classes.btnStatus,
          }}
          size="small"
          style={{
            backgroundColor: item.color,
            color: "#fff",
            cursor: "default",
          }}
        >
          {t(item.label)}
        </Button>
      );
    }
  };
  handleOpenCollapes = (id) => {
    const detailOrder = this.state.detailOrder;
    let payment = detailOrder.payment || [];
    const collapse = this.state.collapse;
    for (let i = 0; i <= payment.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState({
      collapse: collapse,
      editMoneyChange: detailOrder.payment[id].moneyChange,
      editMoneyReceived: detailOrder.payment[id].moneyReceived,
      editPaymentMethod: detailOrder.payment[id].paymentMethod,
    });
  };
  renderCollapse = (row, index) => {
    const { classes, t } = this.props;
    const { collapse = [], detailOrder } = this.state;
    let creator = row.creator || {};
    return (
      <TableRow key={index}>
        <TableCell
          colSpan={headCellsPayment.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <Paper className={classes.containerEdit} square={true}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <LabelForm label={t("orders_detailorder_employee_code")} />
                  <TextForm label={creator.employeeCode} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LabelForm label={t("orders_detailorder_employee_name")} />
                  <TextForm label={creator.employeeName} />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputFormat
                    label={t("orders_detailorder_receive_money")}
                    name="editMoneyReceived"
                    value={this.state.editMoneyReceived}
                    onChange={this.onChange}
                    fullWidth={true}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputFormat
                    label={t("orders_detailorder_change_money")}
                    name="editMoneyChange"
                    value={this.state.editMoneyChange}
                    onChange={this.onChange}
                    fullWidth={true}
                    InputProps={{
                      inputComponent: NumberFormatCustom,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <InputFormat
                    select
                    label={t("orders_detailorder_payment_method")}
                    name="editPaymentMethod"
                    value={this.state.editPaymentMethod}
                    onChange={this.onChange}
                    fullWidth={true}
                  >
                    <MenuItem value="cash">
                      {t("orders_detailorder_payment_method_cash")}
                    </MenuItem>
                    <MenuItem value="card">
                      {t("orders_detailorder_payment_method_card")}
                    </MenuItem>
                  </InputFormat>
                </Grid>
                <Grid container item xs={12} sm={12} justify="flex-end">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.editPaymentOrder(index)}
                  >
                    {t("orders_detailorder_edit")}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = getNumberOnString(value);
    if (name === "editPaymentMethod" || name === "newPaymentMethod")
      state[name] = value;
    this.setState(state);
  };
  caculateTotalReceived = () => {
    const { detailOrder } = this.state;
    let payment = detailOrder.payment || [];
    let totalReceived = 0;
    payment.map((e) => {
      totalReceived += e.moneyReceived - e.moneyChange;
    });
    return totalReceived;
  };
  openDialogConfirm = (index) => {
    let _this = this;
    this.setState({ indexDelete: index }, function () {
      _this.mDialog.handleDialogOpen();
    });
  };
  deletePayment = async () => {
    const { match, t } = this.props;
    let { indexDelete } = this.state;
    let data = {
      orderCode: match.params._id,
      indexPayment: indexDelete,
    };
    this.mDialog.handleDialogClose();
    this.loading.startLoading();
    let check = await this.props.deletePaymentOrder(data);
    if (check.code === 1) {
      this.loading.stopLoading();
      this.mSnackbar.handleClick(
        t("orders_detailorder_delete_payment_success")
      );
      this.setState({ detailOrder: check.data.value });
    } else {
      this.loading.stopLoading();
      this.mSnackbar.handleClick(check.error, "error");
    }
  };
  editPaymentOrder = async (index) => {
    const _this = this;
    const { match, t } = this.props;
    const {
      editMoneyChange,
      editMoneyReceived,
      editPaymentMethod,
      detailOrder,
    } = this.state;
    if (!editMoneyReceived) {
      this.mSnackbar.handleClick(
        t("orders_detailorder_please_fill_in_received_money"),
        "warning"
      );
    } else {
      let data = {
        orderCode: match.params._id,
        indexPayment: index,
        moneyChange: Number(editMoneyChange) || 0,
        moneyReceived: Number(editMoneyReceived) || 0,
        paymentMethod: editPaymentMethod || "cash",
      };
      this.loading.startLoading();
      let check = await this.props.updatePaymentOrder(data);
      if (check.code === 1) {
        this.loading.stopLoading();
        this.mSnackbar.handleClick(
          t("orders_detailorder_edit_payment_success")
        );
        this.setState({ detailOrder: check.data.value }, function () {
          _this.handleOpenCollapes(index);
        });
      } else {
        this.loading.stopLoading();
        this.mSnackbar.handleClick(check.error, "error");
      }
    }
  };
  handleAddPayment = async () => {
    const { t } = this.props;
    const { detailOrder } = this.state;
    let { newMoneyChange, newMoneyReceived, newPaymentMethod } = this.state;
    if (!newMoneyReceived)
      this.mSnackbar.handleClick(
        t("orders_detailorder_please_fill_in_received_money"),
        "warning"
      );
    else {
      this.loading.startLoading();
      let result = await this.props.handleAddPayment({
        moneyChange: newMoneyChange || "0",
        moneyReceived: newMoneyReceived || "0",
        paymentMethod: newPaymentMethod || "cash",
        orderCode: detailOrder.orderCode,
      });
      if (result.code === 1) {
        let check = await this.props.findByCode({
          orderCode: detailOrder.orderCode,
        });
        this.loading.stopLoading();
        if (check.code === 1) {
          this.setState({
            detailOrder: check.data,
            addNewPayment: false,
            newMoneyChange: 0,
            moneyReceived: 0,
          });
        } else {
          this.setState({
            addNewPayment: false,
            newMoneyChange: 0,
            moneyReceived: 0,
          });
        }
        this.mSnackbar.handleClick(
          t("orders_detailorder_add_payment_successfully")
        );
      } else {
        this.loading.stopLoading();
        this.mSnackbar.handleClick(result.error, "error");
      }
    }
  };
  renderFirstRecord = () => {
    const { classes, t, setting } = this.props;
    return (
      <TableRow>
        <TableCell>
          <TextField
            required
            placeholder={t("orders_detailorder_receive_money")}
            type="text"
            name="newMoneyReceived"
            value={this.state.newMoneyReceived}
            onChange={this.onChange}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </TableCell>
        <TableCell align="left">
          <TextField
            required
            placeholder={t("orders_detailorder_change_money")}
            type="text"
            value={this.state.newMoneyChange}
            name="newMoneyChange"
            onChange={this.onChange}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </TableCell>
        <TableCell align="left">
          <Select
            input={<Input name="newPaymentMethod" fullWidth />}
            value={this.state.newPaymentMethod}
            onChange={this.onChange}
          >
            <MenuItem value="cash">
              {t("orders_detailorder_payment_method_cash")}
            </MenuItem>
            <MenuItem value="card">
              {t("orders_detailorder_payment_method_card")}
            </MenuItem>
          </Select>
        </TableCell>
        <TableCell align="left"></TableCell>
        <TableCell colSpan={3} className={classes.containerGroupButtons}>
          <div className={classes.groupButtons}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleAddPayment}
            >
              {t("orders_detailorder_add")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={classes.buttonCancel}
              onClick={this.handleAddNewPayment}
            >
              {t("orders_detailorder_cancel")}
            </Button>
          </div>
        </TableCell>
      </TableRow>
    );
  };
  actionColumn = (item, index) => {
    const { classes, t, setting } = this.props;
    return (
      <div>
        <Button
          variant="contained"
          color="secondary"
          className={classNames(classes.buttonCancel, classes.mlButon)}
          onClick={() => this.openDialogConfirm(index)}
        >
          {t("orders_detailorder_delete")}
        </Button>
      </div>
    );
  };
  handleAddNewPayment = () => {
    if (!this.state.addNewPayment)
      this.setState({
        addNewPayment: !this.state.addNewPayment,
        newMoneyReceived: "",
        newMoneyChange: "",
      });
    else this.setState({ addNewPayment: !this.state.addNewPayment });
  };
  render() {
    const { classes, t, match, location, setting } = this.props;
    let { collapse, addNewPayment, detailOrder = {} } = this.state;
    detailOrder = detailOrder || {};
    let validPhone = _parsePhoneNumber(
      detailOrder.countryCode,
      detailOrder.customerMobile
    ).format_internal;
    let payment = Array.isArray(detailOrder.payment) ? detailOrder.payment : [];
    return (
      <React.Fragment>
        <DialogNotice
          onRef={(dialog) => (this.mDialog = dialog)}
          agree={t("orders_detailorder_delete")}
          disagree={t("orders_detailorder_cancel")}
          title={t("orders_detailorder_notice")}
          content={t(
            "orders_detailorder_payment_record_will_be_delete_immediately_you_can_not_undo_this_action"
          )}
          action={this.deletePayment}
        />
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <Header
          session={t("orders_order")}
          title={`${t("orders_order")} #${match.params._id}`}
          backIcon={true}
          // actionBack={() => this.props.history.push("/order/list")}
          actionBack={() =>
            this.props.history.push(
              location.state && location.state.prevPath
                ? location.state.prevPath
                : "/order/list"
            )
          }
        />
        <Grid container spacing={3}>
          <Grid item xs={12} md={4} xl={3}>
            <Paper>
              <Card>
                <CardHeader
                  classes={{
                    title: classes.titleCardHeader,
                  }}
                  title={t("orders_detailorder_order_info")}
                />
                <Divider />
                <CardContent
                  classes={{
                    root: classes.rootContentCard,
                  }}
                >
                  <Table className={classes.table} aria-label="simple table">
                    <TableBody>
                      <TableRow>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {t("orders_detailorder_customer")}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {detailOrder.customerName}
                            {/* <Link>{detailOrder.customerName}</Link> */}
                          </Typography>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {validPhone}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow selected>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {t("orders_detailorder_order_code")}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {detailOrder.orderCode}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {t("orders_detailorder_date")}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {formatDatetime(detailOrder.createdAt)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow selected>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {t("orders_detailorder_status")}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.customCell}>
                          <Typography
                            classes={{
                              body1: classes.customText,
                            }}
                          >
                            {this.renderStatus(detailOrder.status)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </CardContent>
              </Card>
            </Paper>
          </Grid>
          <Grid item xs={12} md={8} xl={9}>
            <Paper>
              <TableFormat
                onRef={(ref) => (this.mTable = ref)}
                title={
                  t("orders_detailorder_payment") + ` (${setting.currencyCode})`
                }
                headCells={headCellsPayment}
                hiddenPagination={true}
                hiddenInfoRcord={true}
                hiddenSearch={true}
                showCheckBox={false}
                isCollapse={true}
                collapse={collapse}
                renderCollapse={this.renderCollapse}
                handleOpenCollapes={this.handleOpenCollapes}
                showActionToolbar={true}
                titleActionToolbar={t("orders_detailorder_add_new_payment")}
                actionToolbar={this.handleAddNewPayment}
                renderFirstRecord={this.renderFirstRecord}
                actionColumn={this.actionColumn}
                customFirstRecord={addNewPayment ? true : false}
                rows={
                  Array.isArray(payment)
                    ? payment.map((row, index) => {
                        return {
                          id: index,
                          moneyChange: <PriceFormat value={row.moneyChange} />,
                          moneyReceived: (
                            <PriceFormat value={row.moneyReceived} />
                          ),
                          creator: row.creator,
                          paymentMethod: t(
                            `orders_detailorder_payment_method_${
                              row.paymentMethod || "cash"
                            }`
                          ),
                          updatedAt: formatDatetime(row.updatedAt),
                        };
                      })
                    : []
                }
              />
            </Paper>
            <Paper>
              <TableFormat
                onRef={(ref) => (this.mTable = ref)}
                title={t("orders_detailorder_order_item")}
                headCells={headCellsOrderItem}
                hiddenPagination={true}
                hiddenInfoRcord={true}
                hiddenSearch={true}
                showCheckBox={false}
                onRequestSort={false}
                rows={
                  Array.isArray(detailOrder.item)
                    ? detailOrder.item.map((item, index) => {
                        let quantity = item.quantity || 1;
                        return {
                          id: index,
                          name: item.itemName,
                          quantity: quantity,
                          price: (
                            <PriceFormat value={item.itemPrice} />
                            // <NumberFormat
                            //   thousandSeparator={true}
                            //   displayType={"text"}
                            //   value={item.itemPrice}
                            // />
                          ),
                          total: (
                            <PriceFormat value={item.itemPrice * quantity} />
                            // <NumberFormat
                            //   thousandSeparator={true}
                            //   displayType={"text"}
                            //   value={item.itemPrice * quantity}
                            // />
                          ),
                        };
                      })
                    : []
                }
              />
            </Paper>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

DetailOrder.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  setting: state.setting.setting,
});

const mapDispatch = (dispatch) => ({
  findByCode: dispatch.order.findByCode,
  handleAddPayment: dispatch.order.handleAddPayment,
  deletePaymentOrder: dispatch.order.deletePaymentOrder,
  updatePaymentOrder: dispatch.order.updatePaymentOrder,
  getSettings: dispatch.setting.getSettings,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(DetailOrder)));
